"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventdateScroll = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
class EventdateScroll {
    constructor(element) {
        this.element = null;
        this.scrollButton = null;
        this.scroller = null;
        this.itemlist = null;
        this.itemlistInner = null;
        this.items = [];
        this.item_height = 0;
        this.scrollCount = 0;
        this.visible = 5;
        this.height = 405;
        this.cutHeight = 22;
        this.init = () => {
            var _a;
            if (!this.items || ((_a = this.items) === null || _a === void 0 ? void 0 : _a.length) <= this.visible) {
                return;
            }
            this.itemlistInner.height(this.height);
            this.scrollButton.css({ display: 'inline-block' });
            this.scroller.addClass('bounce');
            this.item_height = (0, cash_dom_1.default)(this.items[0]).height();
            let scrollCount = 0;
            this.scrollButton.on('click', () => {
                //$(this.items.last()).after($(this.items[0]).detach());
                this.items = (0, cash_dom_1.default)('.item', this.element);
                this.scrollCount = this.scrollCount + this.visible;
                let scrollTo = this.scrollCount * this.item_height + (this.scrollCount / this.visible * this.cutHeight);
                // console.log(this.scrollCount, this.item_height, this.itemlist.offset().top, scrollTo, this.scroller.offset().top)
                if (this.scrollCount > this.items.length) {
                    scrollTo = 0;
                    this.scrollCount = 0;
                }
                this.itemlistInner[0].scrollTo({
                    top: scrollTo,
                    behavior: 'smooth'
                });
            });
        };
        if (!element) {
            return;
        }
        this.element = element;
        this.scrollButton = (0, cash_dom_1.default)('.scrollButton a', element);
        this.itemlist = (0, cash_dom_1.default)('.datelist', element);
        this.itemlistInner = (0, cash_dom_1.default)('.datelistInner', element);
        this.scroller = (0, cash_dom_1.default)('.scroller', element);
        this.items = (0, cash_dom_1.default)('.item', element);
        //console.log($(this.items[0]).height(), this.visible)
        //this.height = $(this.items[0]).height() * this.visible;
        setTimeout(this.init, 10);
    }
}
exports.EventdateScroll = EventdateScroll;
